import { ApolloLink } from '@apollo/client';

import { Locale } from '@mfe/shared/schema-types';

import { TokenInfo } from './types';

export const getSecureLink = (
  tokenInfo?: TokenInfo,
  locale?: Locale
): ApolloLink =>
  new ApolloLink((operation, forward): any => {
    const context = operation.getContext();
    const headers = { ...context['headers'] };

    const urlParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(urlParams.entries());

    headers['x-query-params'] = JSON.stringify(queryParams);

    if (tokenInfo?.accessToken && tokenInfo?.type) {
      // Add headers for http authentication
      headers['x-auth-token'] = tokenInfo.accessToken;
      headers['x-auth-type'] = tokenInfo.type;
    }

    if (locale) {
      headers['x-locale'] = locale;
    }

    operation.setContext({
      ...context,
      headers,
    });

    return forward(operation);
  });
